import styled from "styled-components";

export const ButtonListContainerStyle = styled.div`
    width: 60%;
    margin: 0 auto;
`;